
import { ajustHeight } from '@/shared/dom.utils';
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';

/**
 * VcardTextAjustHeight
 * - bottomMargin (number, default:64) : Diminue la hauteur de la fenêtre
 * - refresh (boolean, default: false, synchronized) : recalcule la hauteur de la fenêtre
 */
@Component
export default class VcardTextAjustHeight extends Vue {
  // Les props
  @Prop({default: 64}) private bottomMargin!: number
  @PropSync('refresh', {default: false}) private reajustHeight!: boolean
  // Les propriétés
  private height: number = 400

  // Les propriétés calculées
  // Les hooks
  public mounted() {
    window.addEventListener('resize', this.ajustHeight)
    this.$nextTick(this.ajustHeight)
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.ajustHeight)
  }

  // Les méthodes surveillées
  @Watch('reajustHeight')
  private RefreshHeight() {
    if (this.reajustHeight) {
      this.reajustHeight = false
      this.ajustHeight()
    }
  }

  // Les méthodes d'instance
  private ajustHeight() {
    this.height = ajustHeight('vcardtext', this.bottomMargin)
  }

  // Les méthodes statiques
}
